import LunchBoxesScreen from "@/screens/LunchBoxesScreen";

export default LunchBoxesScreen;
